// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const WarrantyStatusModal = t.struct({
    isModalOpen: t.Boolean
}, 'WarrantyStatusModal');

export const getDefaultState = () => new WarrantyStatusModal({
    isModalOpen: false
});

export default WarrantyStatusModal;



// WEBPACK FOOTER //
// ./src/claim/shared/state/warranty-status-modal.js